module.exports = __webpack_public_path__ + "static/media/estilosos_feminino_roupas.fb08cb11.jpg";